import { render, staticRenderFns } from "./ExportInventoryModal.vue?vue&type=template&id=2bbd2b87"
import script from "./ExportInventoryModal.vue?vue&type=script&lang=js"
export * from "./ExportInventoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports